/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	const MULTI_MEASURE_SERIES = '_multiMeasuresSeries';

	class DatasetScopeMultiMeasure extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1802;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}

			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			_.each(spec.widgets, model => {
				if (WidgetUpgradeUtils.isLiveWidgetModel(model)) {
					this._removeSlotPointer(model);
					this._updateSlotmappingDataItem(model);
					this._updateDataViewDataItem(model);
				}
			});

			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		// New implementation can compute this anyway
		_removeSlotPointer(model) {
			if(model.slotmapping && model.slotmapping.multiMeasureSlot) {
				delete model.slotmapping.multiMeasureSlot;
			}
		}

		// New implementation can have 1 multi-measure per dataset
		_updateSlotmappingDataItem(model) {
			model.slotmapping && model.slotmapping.slots && model.slotmapping.slots.forEach(function(slot) {
				slot.dataItems && slot.dataItems.forEach(function(dataItem, index) {
					if(dataItem === MULTI_MEASURE_SERIES) {
						// all multimeasures prior to this upgrader belonged to the 'data' dataset
						slot.dataItems[index] = MULTI_MEASURE_SERIES + '_' + 'data';
					}
				});
			});
		}

		// New implementation can have 1 multi-measure per dataset
		_updateDataViewDataItem(model) {
			if(model.data && !_.isEmpty(model.data.dataViews)) {
				// no multi-layer vis prior to this upgrader had multi-measure support
				model.data.dataViews.forEach(dataview => {
					dataview && dataview.dataItems && dataview.dataItems.forEach(function(dataItem) {
						if(dataItem.id === MULTI_MEASURE_SERIES) {
							// all multimeasures prior to this upgrader belonged to the 'data' dataset
							dataItem.id = MULTI_MEASURE_SERIES + '_data';
						}
					});
				});
			}
		}
	}

	return new DatasetScopeMultiMeasure();
});
